<div class="place-content-center">
  <div>
    <div class="flex items-center justify-between gap-x-2">
      <div>Review</div>
      <div class="relative flex items-center">
        <i class="pi pi-book" style="font-size: 1.5rem"></i>
      </div>
    </div>
  </div>
</div>
